import axios from 'axios';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import { AdminContext } from '../context/AdminContext';
import CookieFunction from '../functions/cookieFunction';

const config = {
  // baseURL: 'https://api.clipsho.com/',
  baseURL: 'https://api2.ochatt.com/',
  // baseURLSocket: 'https://chat.clipsho.com/',
  baseURLSocket: 'https://api2.ochatt.com/',
  isElectron: window.electron ? true : false,

  // baseURL: '/',

  // udata: null,
  // udata: Cookies.get('ochattToken'),
  // uAuth: Cookies.get('userAuthOchatt'),
  // theme: Cookies.get('ochattColor'),

  udata: CookieFunction('get', 'ochattToken'),
  uAuth: CookieFunction('get', 'userAuthOchattId'),
  theme: CookieFunction('get', 'ochattColor'),
  language: CookieFunction('get', 'ochattLang'),

  fetchHandle: async (url, method = 'GET', body = null) => {
    console.log('language', config.language);
    let baseHeaders = {
      'GATEWAY-ID': '30',
      Accept: 'application/json',
      mode: 'no-cors',
      'Access-Control-Allow-Origin': '*',
      withCredentials: false,
      cache: 'default',
    };

    if (config.udata) {
      baseHeaders['Authorization'] = 'Bearer ' + config.udata;
      if (config.uAuth != undefined) {
        baseHeaders['user-authorization'] = config.uAuth;
      }
    }

    let baseConfig = {
      method: method,
      headers: baseHeaders,
    };

    if (body) {
      baseConfig['body'] = JSON.stringify(body);
    }

    const res = await fetch(`${config.baseURL}api/${url}`, baseConfig);
    return await res.json();
  },
  axiosHandle: () => {
    return axios.create({
      baseURL: `${config.baseURL}api/`,
      headers: config.udata
        ? config.uAuth != undefined
          ? {
              Authorization: 'Bearer ' + config.udata,
              'user-authorization': `${config.uAuth}`,
              'clipsho-theme': `${config.theme}`,
              'GATEWAY-ID': '30',
              Accept: 'application/json',
              mode: 'no-cors',
              'Access-Control-Allow-Origin': '*',
              withCredentials: false,
              cache: 'default',
              language: `${CookieFunction('get', 'ochattLang')}`,
              platform: config?.isElectron ? 'appChat' : 'webChat',
            }
          : {
              Authorization: 'Bearer ' + config.udata,
              'clipsho-theme': `${config.theme}`,
              'GATEWAY-ID': '30',
              Accept: 'application/json',
              mode: 'no-cors',
              'Access-Control-Allow-Origin': '*',
              withCredentials: false,
              cache: 'default',
              language: `${CookieFunction('get', 'ochattLang')}`,
              platform: config?.isElectron ? 'appChat' : 'webChat',
            }
        : {
            'GATEWAY-ID': '30',
            Accept: 'application/json',
            'clipsho-theme': `${config.theme}`,
            mode: 'no-cors',
            'Access-Control-Allow-Origin': '*',
            withCredentials: false,
            cache: 'default',
            language: `${CookieFunction('get', 'ochattLang')}`,
            platform: config?.isElectron ? 'appChat' : 'webChat',
          },
      // headers: {
      //   Accept: 'application/json',
      // },
    });
  },
  axiosHandleSocket: () => {
    console.log('language', config.language);
    return axios.create({
      baseURL: `${config.baseURLSocket}api/`,
      headers: config.udata
        ? config.uAuth != undefined
          ? {
              Authorization: 'Bearer ' + config.udata,
              'user-authorization': `${config.uAuth}`,
              'clipsho-theme': `${config.theme}`,
              'GATEWAY-ID': '30',
              Accept: 'application/json',
              mode: 'no-cors',
              'Access-Control-Allow-Origin': '*',
              withCredentials: false,
              cache: 'default',
              language: `${CookieFunction('get', 'ochattLang')}`,
            }
          : {
              Authorization: 'Bearer ' + config.udata,
              'clipsho-theme': `${config.theme}`,
              'GATEWAY-ID': '30',
              Accept: 'application/json',
              mode: 'no-cors',
              'Access-Control-Allow-Origin': '*',
              withCredentials: false,
              cache: 'default',
              language: `${CookieFunction('get', 'ochattLang')}`,
            }
        : {
            'GATEWAY-ID': '30',
            Accept: 'application/json',
            'clipsho-theme': `${config.theme}`,
            mode: 'no-cors',
            'Access-Control-Allow-Origin': '*',
            withCredentials: false,
            cache: 'default',
            language: `${CookieFunction('get', 'ochattLang')}`,
          },
      // headers: {
      //   Accept: 'application/json',
      // },
    });
  },
};
// // console.log("udata", Cookies.get("ochattToken"))
export default config;
